module.exports = __webpack_public_path__ + "img/enter-logo.6fc3c215.svg";